import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Check from 'sushiweb/Icons/all/Check';
import Copy from 'sushiweb/Icons/all/Copy';

const CopyToClipboard = ({ text, size, color }) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1000);
  };

  const CopyTextWrapper = styled.div`
    padding: 0px;
  `;

  return (
    <CopyTextWrapper>
      {copied ? (
        <Check size={size} color={color} />
      ) : (
        <Copy
          size={size}
          color={color}
          onClick={copyToClipboard}
          style={{ cursor: 'pointer' }}
        />
      )}
    </CopyTextWrapper>
  );
};

CopyToClipboard.propTypes = {
  text: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.number,
};

CopyToClipboard.defaultProps = {
  text: '',
  color: 'black',
  size: 22,
};

export default CopyToClipboard;
